import React, { useEffect, useMemo, useCallback, useState } from "react";
import NumberFormat from "react-number-format";
import CopyToClipboard from "react-copy-to-clipboard";
import * as Notification from "../../Notification"
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
} from "../../utils/Currency";
import { useWindowSize } from "../../hook/useWindowSize";
import { dateFormat, RoundNumberOfDigit, RoundNumberOfDigitSGT } from "../../utils/helper";
import { useApp } from "../../contexts";
import { roundNumber } from "../../services/app";
import { getPropByLanguage } from "../../utils/Language";
import { ITEM_TYPES } from "../../constants";
const digitETH = 8;

function Item(props) {
  const size = useWindowSize();
  const isMobile = size.width < 1024 ? true : false;
  const { T, user, language,
    convertToLocalCurrency,
    formatLocalCurrency,
    getCurrency,
  } = useApp();
  const { itemData, selectItem, breedOptions } = props;
  const [orderItem, setOrderItem] = useState({});
  const [orderTotal, setOrderTotal] = useState(0);
  const [orderPrice, setOrderPrice] = useState(0);

  useEffect(() => {
    let total = 0;
    let totalPrice = 0;
    if (itemData.orders_item && itemData.orders_item.length > 0) {
      const orderDog = itemData.orders_item?.find((i) => [ITEM_TYPES.ITEM_TYPE_DOG, ITEM_TYPES.ITEM_TYPE_PET_3D].includes(i.item_type));
      setOrderItem(orderDog || itemData.orders_item[0]);
      itemData?.orders_item?.map((item) => {
        total += item.quantity;
        totalPrice += item.quantity * item.price;
      });
    }
    setOrderTotal(total);
    setOrderPrice(
      convertToLocalCurrency(totalPrice, itemData.orders_item[0]?.ccy || 'USD', getCurrency())
    );
  }, [itemData]);
  const itemName = useCallback(() => {
    let name = T(orderItem?.item_name);
    if (orderItem?.item_type == 9) {
      const breedSelected = (breedOptions || []).find((option) => option.name == orderItem.item_name);
      if (breedSelected) {
        name = breedSelected.nameTranslate[getPropByLanguage(language)]
      }
    }
    return name
  }, 
  [orderItem, breedOptions, language])
  return (
    <>
      {!isMobile ? <>
        <div className="bg-[#fff] rounded-[20px] border-solid border border-[#BDBDBD] lg:flex gap-[0px] items-center px-[40px] py-[20px] mb-[15px]">
            <div className="w-[60%]">
              <div className="flex justify-start items-center gap-3">
              <div
                className={`w-[50px] h-[50px] lg:w-[130px] lg:h-[130px] lg:rounded-[20px] overflow-hidden bg-[#F7F7F7]`}
              >
                <img
                  onClick={selectItem}
                  src={orderItem?.item_image}
                  className={`w-full h-full  ${orderItem?.item_type === 10 ? 'object-contain pt-1' : 'object-cover'}`}
                  alt=""
                />
              </div>
              <div className="flex flex-col flex-1 items-start justify-start max-w-[calc(100%-150px)] merchant-mid mr-[6px]">
                <p
                  onClick={selectItem}
                  className="leading-[25px] cursor-pointer text-[16px] lg:text-[20px] text-[#000] font-[500] mb-[2px] lg:mb-[6px] truncate max-w-[95%]"
                >
                  {itemName()}
                </p>
                <p className="leading-[25px] text-[12px] lg:text-[16px] text-[#000] font-[400] mb-[2px] lg:mb-[4px] w-full">
                  <div className="flex items-center justify-start">
                    <span className="mr-[5px] truncate" onClick={selectItem}>
                      {T("Order #{orderId}").replace("#{orderId}", itemData?.order_name ? itemData?.order_name : '#'+itemData?.order_id)}{" "}
                    </span>
                    <CopyToClipboard
                      text={`${itemData?.order_name ? itemData?.order_name : itemData?.order_id}`}
                      onCopy={(e) => {
                        Notification.success(T("Copied"));
                      }}
                    >
                      <span>
                        <svg
                          className="cursor-pointer"
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M4.5 7.33203C4.5 5.44641 4.5 4.5036 5.08579 3.91782C5.67157 3.33203 6.61438 3.33203 8.5 3.33203H10.5C12.3856 3.33203 13.3284 3.33203 13.9142 3.91782C14.5 4.5036 14.5 5.44641 14.5 7.33203V10.6654C14.5 12.551 14.5 13.4938 13.9142 14.0796C13.3284 14.6654 12.3856 14.6654 10.5 14.6654H8.5C6.61438 14.6654 5.67157 14.6654 5.08579 14.0796C4.5 13.4938 4.5 12.551 4.5 10.6654V7.33203Z"
                            stroke="black"
                          />
                          <path
                            d="M4.5 12.6654C3.39543 12.6654 2.5 11.7699 2.5 10.6654V6.66536C2.5 4.15121 2.5 2.89413 3.28105 2.11308C4.0621 1.33203 5.31918 1.33203 7.83333 1.33203H10.5C11.6046 1.33203 12.5 2.22746 12.5 3.33203"
                            stroke="black"
                          />
                        </svg>
                      </span>
                    </CopyToClipboard>
                  </div>
                </p>
                {orderItem?.item_type !== 10 ? <>
                  {orderItem?.tag_nft_type == 'photo' ? <p className="leading-[24px] text-[12px] lg:text-[16px] text-[#666] font-[400] custom-mb-truncate mb-[2px] lg:mb-[4px]">{T('Photo Art')}</p> : <></>}
                  {orderItem?.tag_nft_type == 'motion' ? <p className="leading-[24px] text-[12px] lg:text-[16px] text-[#666] font-[400] custom-mb-truncate mb-[2px] lg:mb-[4px]">{T('Motion Art')}</p> : <></>}
                </>: <></>}
                
                <p
                  className="leading-[24px] text-[12px] lg:text-[16px] text-[#666] font-[400] custom-mb-truncate"
                  onClick={selectItem}
                >
                  {orderItem?.create_datetime
                    ? dateFormat(orderItem?.create_datetime)
                    : ""}
                </p>
              </div>
              </div>
            </div>
            <div className="w-[40%] grid grid-cols-3 gap-[30px]">
              <div className="flex justify-center">
              <div className="flex justify-center min-w-[12%]">
                {itemData?.status == 3 ? (
                  <p className="text-[#F3850F] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] whitespace-nowrap leading-[30px] bg-[#F5AA191A] rounded-[30px]">
                    {T("Delivered")}
                  </p>
                ): <></>}
                {itemData?.status == 1 ? (
                  <p className="text-[#E5665B] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] whitespace-nowrap leading-[30px] bg-[#E01B1B1A] rounded-[30px]">
                    {T("order.Waiting for Confirmation")}
                  </p>
                ): <></>}
                {itemData?.status == 7 ? (
                  <p className="text-[#E5665B] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] whitespace-nowrap leading-[30px] bg-[#E01B1B1A] rounded-[30px]">
                    {T("order.Cancel")}
                  </p>
                ): <></>}
                {itemData?.status == 10 ? (
                  <p className="text-[#E5665B] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] whitespace-nowrap leading-[30px] bg-[#E01B1B1A] rounded-[30px]">
                    {T("order.Refund")}
                  </p>
                ): <></>}
                {itemData?.status == 11 ? (
                  <p className="text-[#E5665B] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] whitespace-nowrap leading-[30px] bg-[#E01B1B1A] rounded-[30px]">
                    {T("order.Partially Refund")}
                  </p>
                ): <></>}
                {![11, 10, 7, 1, 3].includes(itemData?.status) ? (
                  <p className="text-[#E5665B] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] whitespace-nowrap leading-[30px] bg-[#E01B1B1A] rounded-[30px]">
                    {T("Dispatched")}
                  </p>
                ): <></>}
                </div>
              </div>
              <div className="flex justify-center">
              <div className="text-[#818181] text-[12px] mb-[5px] lg:mb-0 lg:text-[16px] font-[400] flex justify-center min-w-[12%]">
                {orderTotal > 1
                  ? T("{count} items").replace("{count}", orderTotal)
                  : T("1 item")}
              </div>
              </div>
              <div className="flex justify-center">
              <div className="flex flex-row items-center mb-[5px] lg:mb-0 justify-end min-w-[12%] whitespace-nowrap w-full">
                {itemData?.payment_detail?.network ? <NumberFormat
                  value={Number(
                    RoundNumberOfDigit(
                      itemData?.final_amount, digitETH
                    )
                  )}
                  displayType={"text"}
                  className="text-[#272729] text-[16px] font-[600] tracking-[0.2px] whitespace-nowrap custom-mb-truncate"
                  thousandSeparator={true}
                  suffix={" " + itemData?.from_currency_code}
                />: (itemData?.payment_detail && itemData?.payment_detail?.ccy ? (
                  ["ETH", "SGT"].includes(itemData?.payment_detail?.ccy) ? (
                    <NumberFormat
                      value={Number(
                        RoundNumberOfDigit(
                          itemData?.payment_detail?.total_amount, digitETH
                        )
                      )}
                      displayType={"text"}
                      className="text-[#272729] text-[16px] font-[600] tracking-[0.2px] whitespace-nowrap custom-mb-truncate"
                      thousandSeparator={true}
                      suffix={" " + itemData?.payment_detail?.ccy}
                    />
                  ) : (
                    <NumberFormat
                      className="text-[#272729] text-[16px] lg:text-[20px] font-[600] tracking-[0.2px] whitespace-nowrap custom-mb-truncate"
                      value={itemData?.payment_detail?.total_amount}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={prefixCcySymbol(
                        true,
                        itemData?.payment_detail?.ccy || "USD"
                      )}
                      suffix={` ${suffixCcySymbol(
                        true,
                        itemData?.payment_detail?.ccy || "USD"
                      )}`}
                      decimalScale={validateDecimalSeparator(
                        baseCurrencyCode(
                          true,
                          itemData?.payment_detail?.ccy || "USD"
                        )
                      )}
                    />
                  )
                ) : ["ETH", "SGT"].includes(itemData?.from_currency_code) ? (
                  <NumberFormat
                    value={Number(RoundNumberOfDigit(itemData?.final_amount, digitETH))}
                    displayType={"text"}
                    thousandSeparator={true}
                    suffix={" " + itemData?.from_currency_code}
                  />
                ) : (
                  <NumberFormat
                    className="text-[#272729] text-[16px] lg:text-[20px] font-[600] tracking-[0.2px] whitespace-nowrap custom-mb-truncate"
                    value={itemData?.final_amount}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={prefixCcySymbol(
                      true,
                      itemData.from_currency_code || "USD"
                    )}
                    suffix={` ${suffixCcySymbol(
                      true,
                      itemData.from_currency_code || "USD"
                    )}`}
                    decimalScale={validateDecimalSeparator(
                      baseCurrencyCode(true, itemData.from_currency_code || "USD")
                    )}
                  />
                ))
                }
              </div>
              </div>
            </div>
          </div>
      </>: <div
        className={`flex justify-start items-start lg:items-center gap-[8px] py-[9px] suzu_item_mb  lg:px-[27px] lg:py-[20px] lg:gap-[42px] bg-white lg:rounded-[20px] lg:mb-[20px]`}
      >
        <div
          className={`w-[50px] h-[50px]  rounded-[5px] overflow-hidden bg-[#F7F7F7]`}
        >
          <img
            onClick={selectItem}
            src={orderItem?.item_image}
            className={`w-full h-full ${orderItem?.item_type === 10 ? 'object-contain pt-1' : 'object-cover'}`}
            alt=""
          />
        </div>
        <div className="flex flex-col items-start justify-start max-w-[calc(100%-150px)] merchant-mid mr-[6px]">
          <p
            onClick={selectItem}
            className="leading-[25px] text-[14px]  text-[#000] font-[500] mb-[2px] lg:mb-[6px] truncate max-w-[95%]"
          >
            {itemName()}
          </p>
          <p className="leading-[18px] text-[12px] text-[#000] font-[400] mb-[1px] lg:mb-[6px] w-full">
            <div className="flex items-center justify-start">
              <span className="mr-[5px] truncate" onClick={selectItem}>
                {T("Order #{orderId}").replace("#{orderId}", itemData?.order_name ? itemData?.order_name : '#'+itemData?.order_id)}{" "}
              </span>
              <CopyToClipboard
                text={`${itemData?.order_name ? itemData?.order_name : itemData?.order_id}`}
                onCopy={(e) => {
                  Notification.success(T("Copied"));
                }}
              >
                <span>
                  <svg
                    className="cursor-pointer"
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <path
                      d="M4.5 7.33203C4.5 5.44641 4.5 4.5036 5.08579 3.91782C5.67157 3.33203 6.61438 3.33203 8.5 3.33203H10.5C12.3856 3.33203 13.3284 3.33203 13.9142 3.91782C14.5 4.5036 14.5 5.44641 14.5 7.33203V10.6654C14.5 12.551 14.5 13.4938 13.9142 14.0796C13.3284 14.6654 12.3856 14.6654 10.5 14.6654H8.5C6.61438 14.6654 5.67157 14.6654 5.08579 14.0796C4.5 13.4938 4.5 12.551 4.5 10.6654V7.33203Z"
                      stroke="black"
                    />
                    <path
                      d="M4.5 12.6654C3.39543 12.6654 2.5 11.7699 2.5 10.6654V6.66536C2.5 4.15121 2.5 2.89413 3.28105 2.11308C4.0621 1.33203 5.31918 1.33203 7.83333 1.33203H10.5C11.6046 1.33203 12.5 2.22746 12.5 3.33203"
                      stroke="black"
                    />
                  </svg>
                </span>
              </CopyToClipboard>
            </div>
          </p>
          {orderItem?.item_type !== 10 ? <>
            {orderItem?.tag_nft_type == 'motion' ?<p className="leading-[18px] text-[12px] text-[#000000] font-[400] custom-mb-truncate mb-[1px]">{T('Motion Art')}</p> : <></>}
            {orderItem?.tag_nft_type == 'photo' ?<p className="leading-[18px] text-[12px] text-[#000000] font-[400] custom-mb-truncate mb-[1px]">{T('Photo Art')}</p> : <></>}
          </>: <></>}
          
          <p
            className="leading-[18px] text-[12px] lg:text-[16px] text-[#666] font-[400] custom-mb-truncate"
            onClick={selectItem}
          >
            {orderItem?.create_datetime
              ? dateFormat(orderItem?.create_datetime)
              : ""}
          </p>
        </div>
        <div
          className="flex flex-col-reverse items-end justify-end lg:grid lg:grid-cols-3 lg:gap-[30px] flex-1 sm:w-auto  lg:w-[40%]"
          onClick={selectItem}
        >
          <div className="flex justify-center min-w-[12%]">
            {itemData?.status == 3 ? (
              <p className="text-[#F3850F] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] leading-[19px] bg-[#F5AA191A] rounded-[30px]">
                {T("Delivered")}
              </p>
            ) : <></>}
            {itemData?.status == 1 ? (
              <p className="text-[#E5665B] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] leading-[19px]  bg-[#E01B1B1A] rounded-[30px]">
                {T("order.Waiting for Confirmation")}
              </p>
            ) : <></>}
            {itemData?.status == 7 ? (
              <p className="text-[#E5665B] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] leading-[19px]  bg-[#E01B1B1A] rounded-[30px]">
                {T("order.Cancel")}
              </p>
            ) : <></>}
            {itemData?.status == 10 ? (
              <p className="text-[#E5665B] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] leading-[19px]  bg-[#E01B1B1A] rounded-[30px]">
                {T("order.Refund")}
              </p>
            ) : <></>}
            {itemData?.status == 11 ? (
              <p className="text-[#E5665B] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] leading-[19px]  bg-[#E01B1B1A] rounded-[30px]">
                {T("order.Partially Refund")}
              </p>
            ) : <></>}
            { ![3, 1, 7, 10 , 11].includes(itemData?.status) ? (
              <p className="text-[#E5665B] text-[12px] lg:text-[13px] font-[400] px-[8px] lg:px-[16px] leading-[19px]  bg-[#E01B1B1A] rounded-[30px]">
                {T("Dispatched")}
              </p>
            ) : <></>}
            
          </div>
          <div className="text-[#818181] text-[12px] mb-[5px] lg:mb-0 lg:text-[16px] font-[400] flex justify-center min-w-[12%]">
            {orderTotal > 1
              ? T("{count} items").replace("{count}", orderTotal)
              : T("1 item")}
          </div>
          <div className="flex flex-row items-center mb-[5px] lg:mb-0 justify-end min-w-[12%] whitespace-nowrap w-full">
            {itemData?.payment_detail?.network ? <NumberFormat
              value={Number(
                RoundNumberOfDigit(
                  itemData?.final_amount, digitETH
                )
              )}
              displayType={"text"}
              className="text-[#272729] text-[14px] font-[600] tracking-[0.2px] whitespace-nowrap custom-mb-truncate"
              thousandSeparator={true}
              suffix={" " + itemData?.from_currency_code}
            />: (itemData?.payment_detail && itemData?.payment_detail?.ccy ? (
              ["ETH", "SGT"].includes(itemData?.payment_detail?.ccy) ? (
                <NumberFormat
                  value={Number(
                    RoundNumberOfDigit(
                      itemData?.payment_detail?.total_amount, digitETH
                    )
                  )}
                  displayType={"text"}
                  className="text-[#272729] text-[14px] font-[600] tracking-[0.2px] whitespace-nowrap custom-mb-truncate"
                  thousandSeparator={true}
                  suffix={" " + itemData?.payment_detail?.ccy}
                />
              ) : (
                <NumberFormat
                  className="text-[#272729] text-[14px] lg:text-[20px] font-[600] tracking-[0.2px] whitespace-nowrap custom-mb-truncate"
                  value={itemData?.payment_detail?.total_amount}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={prefixCcySymbol(
                    true,
                    itemData?.payment_detail?.ccy || "USD"
                  )}
                  suffix={` ${suffixCcySymbol(
                    true,
                    itemData?.payment_detail?.ccy || "USD"
                  )}`}
                  decimalScale={validateDecimalSeparator(
                    baseCurrencyCode(
                      true,
                      itemData?.payment_detail?.ccy || "USD"
                    )
                  )}
                />
              )
            ) : ["ETH", "SGT"].includes(itemData?.from_currency_code) ? (
              <NumberFormat
                value={Number(RoundNumberOfDigit(itemData?.final_amount, digitETH))}
                displayType={"text"}
                thousandSeparator={true}
                suffix={" " + itemData?.from_currency_code}
              />
            ) : (
              <NumberFormat
                className="text-[#272729] text-[14px] lg:text-[20px] font-[600] tracking-[0.2px] whitespace-nowrap custom-mb-truncate"
                value={itemData?.final_amount}
                displayType={"text"}
                thousandSeparator={true}
                prefix={prefixCcySymbol(
                  true,
                  itemData.from_currency_code || "USD"
                )}
                suffix={` ${suffixCcySymbol(
                  true,
                  itemData.from_currency_code || "USD"
                )}`}
                decimalScale={validateDecimalSeparator(
                  baseCurrencyCode(true, itemData.from_currency_code || "USD")
                )}
              />
            ))
            }
          </div>
        </div>
      </div>}
    </>
  );
}

export default Item;
